import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { convertToJalaliWithoutTime } from "../../../../../tools/tools";
import { Breadcrumb, Button, Steps } from "antd";
import OprationResult from "../../../../auxiliary/opration/opration";
import { _adr } from "../../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import CWLayout from "../../../../changeOwnership/change/cwLayout";
import { Content } from "antd/es/layout/layout";
import Profile from "../../profile/profile";

const CowFinal = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const formData = useSelector((state) => state?.from?.coownership);
	const dispatch = useDispatch();
	const location = useLocation();

	return (
		<CWLayout>
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<Profile Profile={formData?.purchase || {}} state />
						<br />
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={3}
										responsive
										items={[
											{
												title: "اطلاعات خریدار(حقیقی)",
											},
											{
												title: "آپلود مدرک شناسایی (حقیقی)",
											},
											{
												title: "بررسی نهایی",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-prefactor">
								<OprationResult
									isSucess={true}
									list={[
										{
											label: "تاریخ و ساعت",
											value: (
												<>
													{/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
													<span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
												</>
											),
										},
										{
											label: "نوع سرویس",
											value: location?.state?.serviceType,
										},
										{
											label: "شماره سیم کارت",
											value: location?.state?.msisdn,
										},
										{
											label: "شماره کیت جدید",
											value: location?.state?.iccid,
										},
										{
											label: "کد پیگیری",
											value: location?.state?.strFollwUpCode,
										},
									]}
								/>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button
									className="btn-normal btn-print"
									onClick={() => {
										window.print();
									}}
									type="default"
									icon={<i className="icon-print"></i>}>
									چاپ رسید
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
		</CWLayout>
	);
};

export default CowFinal;
